import * as honeycombIcons from '@flixbus/honeycomb-icons-react';

import { capitalize } from './wordUtils';

export function isValidIcon(icon) {
  return icon !== '' && honeycombIcons[`Icon${capitalize(icon)}`] !== undefined;
}
